import React, { useState } from "react";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput } from "@material-ui/core";
import { panelUsersAuthStyle } from "../../panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { editarCliente } from "../../../domain/api/ClientesApi";
import { Store } from "react-notifications-component";

export const EditCliente = ({ reload, clearData, data, handleCloseModal,primaryColor }) => {
    const classes = panelUsersAuthStyle();
    const dispatch = useDispatch();
    const [Nombre, setNombre] = useState(data.nombre);
    const [Celular, setCelular] = useState(data.celular);
    const [Documento, setDocumento] = useState(data.documento);

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });

        handleCloseModal();
        reload();
    };

    const editCliente = async (request) => {
        const response = await editarCliente(dispatch, request);
        try {
            if (response) {
                handledAlert("Actualizado Exitosamente!", `Cliente actualizado con éxito!`, "success");
            } else {
                handledAlert("Ocurrió un error!", "Ocurrió un error al cambiar el estado", "danger");
            }
        } catch {
            handledAlert("Ocurrió un error!", "Error interno", "danger");
        }
    };

    const editar = () => {
        const request = {
            id: data.id,
            nombre: Nombre,
            celular: Celular,
            documento: Documento
        };
        editCliente(request);
    };
    const inputStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
        borderRadius:'10px'
    };

    return (
        <form>
            <Grid container spacing={3} style={{ textAlign: "left" }}>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre"style={{marginTop:'-1%'}}>Nombre</InputLabel>
                        <OutlinedInput
                            id="nombre"
                            type="nombre"
                            name='nombre'
                            defaultValue={data.nombre}
                            required
                            onChange={e => {
                                setNombre(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={inputStyles}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre"style={{marginTop:'-1%'}}>Celular</InputLabel>
                        <OutlinedInput
                            id="celular"
                            type="Celular"
                            name='celular'
                            defaultValue={data.celular}
                            required
                            onChange={e => {
                                setCelular(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={inputStyles}

                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} sm={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nombre"style={{marginTop:'-1%'}}>Documento</InputLabel>
                        <OutlinedInput
                            id="Documento"
                            type="documento"
                            name='Documento'
                            defaultValue={data.documento}
                            required
                            onChange={e => {
                                setDocumento(e.target.value);
                            }}
                            startAdornment={<InputAdornment position="start">-</InputAdornment>}
                            labelWidth={100}
                            style={inputStyles}

                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className={classes.wrapper}>
                <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", marginRight: '10px', width: "150px",borderRadius:'10px' }}
                        onClick={handleCloseModal}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "150px",borderRadius:'10px' }}
                        onClick={editar}
                    >
                        Editar
                    </Button>
                </Grid>
            </div>
        </form>
    );
};
